(() => {
  'use strict';

  const slugify = (value) => {
    const base = value
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return base || 'section';
  };

  const getHeaderOffset = () => {
    const value = getComputedStyle(document.documentElement).getPropertyValue('--header-group-height');
    const height = Number.parseFloat(value);
    return Number.isFinite(height) ? height + 24 : 96;
  };

  const wrapTables = (content) => {
    content.querySelectorAll('table').forEach((table) => {
      if (table.parentElement?.classList.contains('gl-policy-page__table-scroll')) return;
      const wrapper = document.createElement('div');
      wrapper.className = 'gl-policy-page__table-scroll';
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('tabindex', '0');
      wrapper.setAttribute('aria-label', 'Scrollable table');
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    });
  };

  const buildToc = (root) => {
    const content = root.querySelector('[data-gl-policy-content]');
    const tocColumn = root.querySelector('[data-gl-policy-toc-column]');
    const mobileToc = root.querySelector('[data-gl-policy-mobile-toc]');
    if (!content || !tocColumn || !mobileToc) return;

    wrapTables(content);
    const usedIds = new Set(Array.from(document.querySelectorAll('[id]')).map((element) => element.id));
    const headings = Array.from(content.querySelectorAll('h2'));
    const items = headings.map((heading) => {
      if (!heading.id) {
        const base = slugify(heading.textContent.trim());
        let id = base;
        let index = 2;
        while (usedIds.has(id)) id = `${base}-${index++}`;
        heading.id = id;
        usedIds.add(id);
      }
      return { id: heading.id, label: heading.textContent.trim(), heading };
    }).filter((item) => item.label);

    if (items.length < 3) return;
    tocColumn.hidden = false;
    mobileToc.hidden = false;

    const links = [];
    root.querySelectorAll('[data-gl-policy-toc-list]').forEach((list) => {
      list.replaceChildren();
      items.forEach((item) => {
        const entry = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${item.id}`;
        link.textContent = item.label;
        link.addEventListener('click', (event) => {
          event.preventDefault();
          item.heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (mobileToc.open) mobileToc.open = false;
          history.replaceState(null, '', `#${item.id}`);
        });
        entry.appendChild(link);
        list.appendChild(entry);
        links.push({ id: item.id, link });
      });
    });

    const setActive = (id) => {
      links.forEach(({ id: linkId, link }) => {
        if (linkId === id) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    };

    const observer = new IntersectionObserver((entries) => {
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
      if (visible) setActive(visible.target.id);
    }, { rootMargin: `-${getHeaderOffset()}px 0px -70% 0px`, threshold: 0 });

    items.forEach(({ heading }) => observer.observe(heading));
    const hash = decodeURIComponent(window.location.hash.slice(1));
    setActive(items.some(({ id }) => id === hash) ? hash : items[0].id);
  };

  const init = () => document.querySelectorAll('[data-gl-policy-page]').forEach(buildToc);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
